import React, { useState, useEffect } from 'react';
import XhrRequestError from '../../lib/XhrRequestError';

// Un custom hook que maneja el conteo de clicks
export function useMismatchVersion() {
  const [showMMVersionDialog, setShowMMVDialog] = React.useState<boolean>(false);

  const isMMVError = (err: any) => {
    if (err instanceof XhrRequestError) setShowMMVDialog(err.isMismatchVersionError());
  };

  const onCancelMMV = () => {
    setShowMMVDialog(false);
  };

  return { showMMVersionDialog, isMMVError, onCancelMMV };
}
